import { KeyboardEvent } from 'react';
import { TextInput } from './TextInput';
import { useTranslation } from '../../i18n/i18n';
import { halfRow, InputGrid } from './InputGrid';
import { AccountInfoBox } from './AccountInfoBox';

export type CustomerModel = {
	email: string;
	company: string;
	firstname: string;
	lastname: string;
	phone: string;
};

type CustomerSummaryProps = { customer: CustomerModel };
export function CustomerSummary({ customer }: CustomerSummaryProps): JSX.Element {
	return (
		<AccountInfoBox>
			<dl>
				<dd>{customer.company}</dd>
				<dd>
					{customer.firstname} {customer.lastname}
				</dd>
				<dd>{customer.email}</dd>
				<dd>{customer.phone}</dd>
			</dl>
		</AccountInfoBox>
	);
}

type CustomerInputProps = {
	model: CustomerModel;
	onChange: (val: CustomerModel) => void;
	onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
};
export const CustomerInput = ({ model, onChange, onKeyPress }: CustomerInputProps): JSX.Element => {
	const t = useTranslation().accountPage;
	return (
		<InputGrid>
			<TextInput
				id="customer-email"
				autocomplete="email"
				placeholder={t.emailAddress}
				value={model.email}
				type="email"
				onChange={(e) => onChange({ ...model, email: e.target.value })}
				autoFocus={true}
				onKeyDown={onKeyPress}
				nextElement="customer-company"
			/>
			<TextInput
				id="customer-company"
				autocomplete="organization"
				placeholder={t.companyName}
				value={model.company}
				onChange={(e) => onChange({ ...model, company: e.target.value })}
				onKeyDown={onKeyPress}
				nextElement="customer-firstname"
			/>
			<TextInput
				id="customer-firstname"
				className={halfRow}
				autocomplete="given-name"
				placeholder={t.firstName}
				value={model.firstname}
				onChange={(e) => onChange({ ...model, firstname: e.target.value })}
				onKeyDown={onKeyPress}
				nextElement="customer-lastname"
				maxLength={32}
			/>
			<TextInput
				id="customer-lastname"
				className={halfRow}
				autocomplete="family-name"
				placeholder={t.surname}
				value={model.lastname}
				onChange={(e) => onChange({ ...model, lastname: e.target.value })}
				onKeyDown={onKeyPress}
				nextElement="customer-phone"
				maxLength={32}
			/>
			<TextInput
				id="customer-phone"
				autocomplete="tel"
				placeholder={t.phoneNumber}
				value={model.phone}
				onChange={(e) => onChange({ ...model, phone: e.target.value })}
				onKeyDown={onKeyPress}
			/>
		</InputGrid>
	);
};
